// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tin: CountryValidator<"BZ"> = createValidator(
  "bz.tin",
  29,
);

export default tin;
export const compact = tin.compact;
export const format = tin.format;
export const validate = tin.validate;
export const generate = (): string =>
  tin.generate?.() ??
  (() => {
    throw new Error(
      "Validator bz.tin cannot generate values",
    );
  })();
